import { USER_ROLE } from "common/enum";

const options = [
  {
    key: "companies",
    label: "sidebar.companies",
    leftIcon: "ion-folder",
    requieredRole: [
      USER_ROLE.ADMIN
    ]
  },
  {
    key: "pricing",
    label: "pricing",
    leftIcon: "ion-folder",
    requieredRole: [
      USER_ROLE.ADMIN
    ]
  },
  {
    key: "tickets",
    label: "tickets",
    leftIcon: "ion-folder",
    requieredRole: [
      USER_ROLE.ADMIN
    ]
  },
  {
    key: "calcprice",
    label: "calc.price",
    leftIcon: "ion-folder",
    requieredRole: [
      USER_ROLE.ADMIN
    ]
  },

];
export default options;
